/* eslint no-shadow: ["error", { "allow": ["state"] }] */
/* eslint no-param-reassign: ["error", { "props": false }] */
import Vue from 'vue';
import * as mTypes from 'store/mutation-types';

const state = {
  conferencerule: {},
  error: null,
};

const getters = {
  conferencerule: state => state.conferencerule,
  error: state => state.error,
};

const actions = {
  fetch({ commit }, payload) {
    const path = `${payload.user.data.selectedRole.role}s/${payload.user.data.selectedRole.id}`;
    return Vue.http.get(`${process.env.BACKEND_API_URL}api/${path}/products/${payload.productId}/conferencerules/${payload.ruleId}`)
      .then((response) => {
        commit(mTypes.DATA_FETCHED, response);
      });
  },
  save({ commit }, payload) {
    const path = `${payload.user.data.selectedRole.role}s/${payload.user.data.selectedRole.id}`;
    let request;
    if (payload.rule.id) {
      request = Vue.http.put(`${process.env.BACKEND_API_URL}api/${path}/products/${payload.rule.productId}/conferencerules/${payload.rule.id}`, payload.rule);
    } else {
      request = Vue.http.post(`${process.env.BACKEND_API_URL}api/${path}/products/${payload.rule.productId}/conferencerules`, payload.rule);
    }
    return request
      .then((response) => {
        commit(mTypes.DATA_FETCHED, response);
      });
  },
  delete({ commit }, payload) {
    const path = `${payload.user.data.selectedRole.role}s/${payload.user.data.selectedRole.id}`;
    return Vue.http.delete(`${process.env.BACKEND_API_URL}api/${path}/products/${payload.productId}/conferencerules/${payload.id}`)
      .then(() => {
      })
      .catch((error) => {
        commit(mTypes.DATA_ERROR, error);
      });
  },
};

const mutations = {
  [mTypes.DATA_FETCHED](state, conferencerules) {
    state.conferencerule = {};
    state.conferencerule = conferencerules.body;
    state.error = null;
  },
  [mTypes.DATA_ERROR](state, error) {
    state.error = error;
  },
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};



// WEBPACK FOOTER //
// ./src/store/modules/conferencerules/conferencerule.js